/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListCatalogModelAccess } from "../../funcs/llmModelsListCatalogModelAccess.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListModelCatalogAccessRequest$inboundSchema,
};

export const tool$llmModelsListCatalogModelAccess: ToolDefinition<typeof args> =
  {
    name: "llm-models-list-catalog-model-access",
    description: `List organizations with access to a cluster model

Cluster operator reverse lookup showing availability and activation for one cluster catalog id.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmModelsListCatalogModelAccess(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
